import StepImage from "../../../../../../assets/images/scene_5.png";

import styles from "./stepTwo.module.scss";

const StepTwo = () => {
  return (
    <div className={styles.StepTwo}>
      <div className={styles.ImageContainer}>
        <img src={StepImage} alt="" />
      </div>
      <div className={styles.Content}>
        <p className={styles.Title}>
          Make your <strong>history</strong> count
        </p>
        <p className={styles.SubTitle}>
          Your future is bright your credit rating with us to measure up to your
          ambition.
        </p>
      </div>
    </div>
  );
};

export default StepTwo;
